import React from 'react';

interface Attribute {
    trait_type: string;
    value: string | number;
}

// This interface should align with the `certificate` object within the `ItemDetailsResult`
// from your web3Service.ts.
export interface Certificate {
    name: string;
    description: string;
    image: string | null;
    attributes?: Attribute[];
}

interface CertificateDetailsProps {
    certificate: Certificate | null;
    tokenId: string;
    currentUri: string;
    onUseAsTemplate?: () => void;
    useAsTemplateLabel?: string;
}

const CertificateDetails: React.FC<CertificateDetailsProps> = ({ certificate, tokenId, currentUri, onUseAsTemplate, useAsTemplateLabel }) => {
    if (!certificate) {
        return <p>No certificate details available.</p>;
    }

    const productUrl = `https://bc.transparencychain.org/?token=${tokenId}`;

    return (
        <div className="certificate-details">
            <div className="certificate-details-header">
                <h3>Certificate Details</h3>
                {onUseAsTemplate && (
                    <button onClick={onUseAsTemplate} className="template-btn">
                        {useAsTemplateLabel || 'Use as template'}
                    </button>
                )}
            </div>
            {certificate.image && (
                <img
                    src={certificate.image}
                    alt={certificate.name}
                    style={{ maxWidth: '200px', borderRadius: '8px', marginBottom: '1rem' }}
                />
            )}
            <p><strong>Name:</strong> {certificate.name}</p>
            <p><strong>Description:</strong> {certificate.description}</p>

            {certificate.attributes && certificate.attributes.length > 0 && (
                <div className="attributes-section">
                    <strong>Attributes:</strong>
                    <ul>
                        {certificate.attributes.map((attr, index) => (
                            <li key={index}>
                                <strong>{attr.trait_type}:</strong> {String(attr.value)}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <p><strong>Product Certificate:</strong> <a href={productUrl} target="_blank" rel="noopener noreferrer">{productUrl}</a></p>
            <p><strong>Current Certificate URI:</strong> <a href={currentUri} target="_blank" rel="noopener noreferrer">IPFS</a></p>

        </div>
    );
};

export default CertificateDetails;